export const serviceConstants = {
    // Fall back to the host the app is served from, so the API works whether the
    // frontend is opened as localhost or via the machine's network IP.
    API_HOST_NAME: process.env.REACT_APP_API_HOST_NAME
        || `${window.location.protocol}//${window.location.hostname}:8086`
    // Add other constants as needed
};

const statuses = ["New", "Interested", "Follow-up", "Converted", "Not Answered"];

export const leadStatuses = [
    { _id: 1, label: "New", value: "new", color: "#1e40af", bgColor: "#dbeafe" },
    { _id: 2, label: "Interested", value: "interested", color: "#166534", bgColor: "#dcfce7" },
    { _id: 3, label: "Not Interested", value: "not_interested", color: "#1f2937", bgColor: "#f3f4f6" },
    { _id: 4, label: "Follow-Up", value: "follow_up", color: "#854d0e", bgColor: "#fef9c3" },
    { _id: 5, label: "Converted", value: "converted", color: "#6b21a8", bgColor: "#f3e8ff" },
    { _id: 6, label: "Not Answered", value: "not_answered", color: "#1f2937", bgColor: "#f3f4f6" }
];

export const roles = [
    {
        label: "Admin",
        value: "admin"
    },
    {
        label: "Floor Manager",
        value: "floorManager"
    },
    {
        label: "Desk Manager",
        value: "deskManager"
    },
    {
        label: "Agent",
        value: "agent"
    }
];

export const floors = [
    {
        label: "Conversion",
        value: "conversion"
    },
    {
        label: "Retention",
        value: "retention"
    }
];
